module.exports = __webpack_public_path__ + "770584846f1faf90a1d04f2a5ba82781.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/guitar-edgy-s.png
// module id = 1283
// module chunks = 0